module.exports = __webpack_public_path__ + "img/icon-notice.656ff004.svg";